import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import './AiroPageContainer.scss';
import './../../GPBMobile/SpecialPageContainer.scss';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

export function mapProps() {
    return;
}

export function mapDispatch() {
    return;
}

export class AiroPageContainer extends React.Component<RouteProps, {}> {

    render() {
        return (
            <div className='main-airo-container'>
                <img
                    className='airo-logo'
                    src={require('../../assets/airo-logo.svg')}
                />
                <div className='airo-container'>
                    <div>
                        Теперь качественная химчистка стала еще выгоднее и доступнее: курьеры Airo заберут вещи в любое время - вам не придется менять планы.
                        <br/>
                        <br/>
                        Очистят все: куртки, пальто, футболки, ковры и шторы.
                        <br/>
                        <br/>
                        Привезут чистые и отглаженные вещи через 48 часов.
                        <br/>
                        <br/>
                        Чистота без хлопот и переплат: скидки до 15% и бесплатная доставка для заказов химчистки от 2490₽. <a href='https://airo.ru/'>Подробнее</a>.
                    </div>
                    <img src={require('./../../assets/airo-image.svg')}/>
                </div>
                <div className='airo-container__button'>
                    <button onClick={() => location.href = 'https://airo.ru/external/iframe/back-call-kons-app'}>
                        Заказать
                    </button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Airo/AiroPageContainer.tsx